import styles from './cart-item-card.module.css';
import { AmountButton } from '../../ui/amount-button/amount-button';
import { DeleteButton } from '../../ui/delete-button/delete-button';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { DECREASE_ITEM, DELETE_ITEM, INCREASE_ITEM } from '../../services/actions/cart';
import { priceFormat } from '../common/utils';
import { TItemInCart, TLanguage } from '../../types/types';

export const CartItemCard = ({ src, id, description, qty, price }: TItemInCart) => {
  const dispatch = useAppDispatch();
  const discount = useAppSelector(store => store.cart.promoDiscount ?? 0);
  let { language } = useAppSelector(store => store.language ?? 'RU');
  language = language.toLowerCase();
  const discountedPrice = Math.floor((price - price * (discount / 100)) * qty);

  const onDelete = () => {
    dispatch({
      type: DELETE_ITEM,
      id
    });
  };

  const decrease = () => {
    if (qty === 1) {
      onDelete();
    } else {
      dispatch({
        type: DECREASE_ITEM,
        id
      });
    }
  };

  const increase = () => {
    dispatch({
      type: INCREASE_ITEM,
      id
    });
  };

  return (
    <div className={`${styles.product}`}>
      <div className={styles.productBox}>
        <img className={styles.img} src={src} alt='фото товара.' />
        <p className={styles.text}>{description[language as keyof TLanguage]}</p>
      </div>

      <div className={styles.amountbox}>
        <AmountButton onClick={decrease}>-</AmountButton>
        <p className={styles.amount}>{qty}</p>
        <AmountButton onClick={increase}>+</AmountButton>
      </div>

      <div className={styles.price}>
        <p className={`${styles.price} ${discount && styles.exPrice}`}>
          {priceFormat(price * qty)}
        </p>
        {discount && <p className={styles.price}>{priceFormat(discountedPrice)}</p>}
      </div>
      <DeleteButton onDelete={onDelete} extraClass={styles.delete_button} />
    </div>
  );
};
